module.exports = __webpack_public_path__ + "static/stava_ipad_1-f813c1fa759ab632c7d7193d8c148a33.png";